import { useState, useEffect } from 'react'

/**
 * Hook for handling closing when clicking outside of an element
 */
export const useDetectOutsideClick = (el, initialState) => {
  const [isActive, setIsActive] = useState(initialState)
  useEffect(() => {
    const onClick = e => {
      // If the active element exists and there's a click outside of the element
      //  toggle its active status
      if (el.current !== null && !el.current.contains(e.target)) {
        setIsActive(!isActive)
      }
    }

    // Create an event listener for clicks
    if (isActive) {
      window.addEventListener('click', onClick)
    }

    // Clean up listener
    return () => {
      window.removeEventListener('click', onClick)
    }
  }, [isActive, el])

  return [isActive, setIsActive]
}
